import { useCallback } from 'react'
import {
  useUpdateEnterpriseAccountMutation,
  type UpdateEnterpriseAccountMutationVariables,
} from 'domains/account-management/api'

export const useUpdateEnterpriseAccount = () => {
  const [triggerMutation, { data, loading, error, called }] = useUpdateEnterpriseAccountMutation()

  const submit = useCallback(
    (variables: UpdateEnterpriseAccountMutationVariables) =>
      triggerMutation({
        variables,
      }),
    [triggerMutation]
  )

  return {
    submit,
    apiSuccess: data?.enterpriseAccountUpdate && !error,
    apiLoading: loading,
    apiCalled: called,
    apiError: error,
  }
}
